import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useMemo } from 'react';
import { useRouter } from 'next/router';
import { seesaw } from '@/utils/string';
import clzz from 'classnames';
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
export default function Linker(props) {
    var router = useRouter();
    var className = props.className, style = props.style, onClick = props.onClick, children = props.children, cancelBubble = props.cancelBubble, href = props.href, isHash = props.isHash, isAddress = props.isAddress, text = props.text, target = props.target, isDApp = props.isDApp, isToken = props.isToken;
    var handlerClick = useCallback(function(e) {
        cancelBubble && e.stopPropagation();
        e.preventDefault(); // Disable link if click hander return false
        if (false === (onClick === null || onClick === void 0 ? void 0 : onClick(e))) {
            return;
        }
        target === '_blank' ? window.open(href) : router.push(href);
    }, [
        href,
        target
    ]);
    var linkClass = useMemo(function() {
        return clzz({
            'font-mono': isHash || isAddress
        }, className, 'linker text-primary cursor-pointer');
    }, [
        isHash,
        className
    ]);
    var renderContent = useMemo(function() {
        if (children !== undefined) {
            return children;
        }
        var str = text || String(href);
        if (isHash) {
            return seesaw({
                raw: str,
                isHash: true
            });
        }
        if (isDApp) {
            var ref = _slicedToArray(str.split(':'), 2), symbol = ref[0], tmp = ref[1], type = tmp === void 0 ? 'dapp' : tmp;
            return(/*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-[16px] font-mono !text-primary",
                        children: symbol
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-desc h-[21px] inline-flex bg-[#E5E6EB] rounded-[4px] px-[6px] ml-[8px] text-[15px] items-center justify-center ",
                        children: type
                    })
                ]
            }));
        }
        if (isToken) {
            var ref1 = _slicedToArray(str.split(':'), 2), symbol1 = ref1[0], tmp1 = ref1[1], type1 = tmp1 === void 0 ? 'token' : tmp1;
            return(/*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-[16px] font-mono !text-primary",
                        children: symbol1
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-desc h-[21px] inline-flex bg-[#E5E6EB] rounded-[4px] px-[6px] ml-[8px] text-[15px] items-center justify-center ",
                        children: type1
                    })
                ]
            }));
        }
        if (isAddress) {
            return seesaw({
                raw: str,
                isAddress: true
            });
        }
        return str;
    }, [
        children,
        isHash,
        text,
        href,
        isDApp,
        isToken
    ]);
    return(/*#__PURE__*/ _jsx("a", {
        onClick: handlerClick,
        style: style,
        className: linkClass,
        href: String(href),
        rel: "noopener noreferrer",
        children: renderContent
    }));
};
